import { css } from "lit";

/* Custom styles for PPS (agent id 8236076d-d665-409f-a8ba-b89b25f332e5) */
export const customUserPpsStyles = css`
  .hollo-agent-pps {
    /* Orange: #FC9223 */
    --hollo-trigger-bg: linear-gradient(to right, #FC9223 0%, #FC9223 100%);
    --hollo-highlight-color: #FC9223;
    --hollo-recorder-send-bg: #FC9223;
    --hollo-mic-icon-color: #FC9223;
    --hollo-trigger-shadow: rgba(252, 146, 35, 0.5);
    --hollo-input-focus-color: rgba(252, 146, 35, 0.3);
    --hollo-typing-dot-color: #FC9223;

    /* Green: #93C750 */
    --hollo-phone-btn-bg: #93C750;

    /* Dark Blue: #0F4159 */
    --hollo-user-bubble-bg: #0F4159;
    --hollo-send-btn-bg: #0F4159;

    /* Phone Number Gradient: #0F4159 to #0CACE7 */
    --hollo-phone-number-gradient: linear-gradient(90deg, #0F4159 0%, #0CACE7 100%);
  }

  .hollo-agent-pps .hollo-popup-gradient-minimalist::before,
  .hollo-agent-pps .hollo-popup-gradient-minimalist::after {
    display: none !important;
  }
`;
